import styled from 'styled-components'

import { theme } from '../../theme'

export const Title = styled.div`
  color: ${theme('colors.slate')};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5em;
  margin-bottom: 8px;
  text-align: center;
`

export const Body = styled.div`
  color: ${theme('colors.slate')};
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5em;
  text-align: center;
  overflow: auto;
`

export const Bold = styled.span`
  color: ${theme('colors.green')};
  font-weight: bold;
`

export default {
  Title,
  Body,
  Bold,
}
